import { render } from "./RedZonesImage.vue?vue&type=template&id=68256cf0"
import script from "./RedZonesImage.vue?vue&type=script&lang=js"
export * from "./RedZonesImage.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src1709076162/src/harpia-offshore-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__